var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "log-out"
  }, /*#__PURE__*/React.createElement("g", {
    id: "symbol"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 3C3.89543 3 3 3.89543 3 5V19C3 20.1046 3.89543 21 5 21H11C12.1046 21 13 20.1046 13 19V17H11V19H5V5H11V7H13V5C13 3.89543 12.1046 3 11 3H5Z",
    fill: "#00263A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2929 16.2928L17.5858 13H8V11H17.5858L14.2929 7.70706L15.7071 6.29285L20.7071 11.2928C21.0976 11.6834 21.0976 12.3165 20.7071 12.7071L15.7071 17.7071L14.2929 16.2928Z",
    fill: "#00263A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.6f698c289715f0928f431eba7c88b476.svg";
export { ForwardRef as ReactComponent };